import moment from 'moment'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { MdMessage } from 'react-icons/md'
import { ActionIcon, Stack, Text } from '@mantine/core'
import { Modal } from '@/components/Elements/Modals'
import { BookingModel } from '@/features/bookings/types/models'
import { convertListNamesToNames } from '@/helpers/common/utils'
import { usePopup } from '@/hooks'
import useStyles from './QuickReplySection.styles'

interface IProps {
  onSelect: (tag: string, text: string) => void
  lastDate: any
  booking: BookingModel
  isSubmitting: boolean
  disabled: boolean
}

export const QuickReplySection = (props: IProps) => {
  const { t } = useTranslation()
  const { classes, cx } = useStyles()
  const { visible, open, close } = usePopup()

  const processQuickReplies = (text: string) => {
    //console.log('BOOKING:' + JSON.stringify(props.booking))
    return text
      .replace('#NAME#', props.booking?.user?.first_name || '')
      .replace('#CHILDREN_SENTENCE#', convertListNamesToNames(props.booking?.children_names))
  }

  const quickRepliesList = useMemo(() => {
    return [
      {
        tag: 'start',
        title: t('chat.booking_confirmation_title'),
        text: processQuickReplies(t('chat.booking_confirmation_text')),
        clickable: true,
      },
      {
        tag: 'during',
        title: t('chat.after_first_night_title'),
        text: processQuickReplies(t('chat.after_first_night_text')),
        clickable: true,
      },
      {
        tag: 'finish',
        title: t('chat.after_departure_title'),
        text: processQuickReplies(t('chat.after_departure_text')),
        clickable:
          moment().isAfter(props.lastDate) && moment().add(-5, 'days').isBefore(props.lastDate),
      },
    ]
  }, [props.lastDate])

  const showQuickReplies = () => {
    if (!props.disabled) {
      open(false)
    }
  }

  const quickReplySelected = (item: any) => {
    if (item.clickable) {
      close()
      props.onSelect(item.tag, item.text)
    }
  }

  return (
    <>
      {' '}
      <ActionIcon
        disabled={props.disabled || !props.booking}
        onClick={() => showQuickReplies()}
        variant="transparent"
        loading={props.isSubmitting}
        color={'secondary'}
      >
        <MdMessage size="24" />
      </ActionIcon>
      <Modal opened={visible} onClose={close} centered title={t('chat.quick_replies')}>
        <Stack>
          {quickRepliesList.map((item, i) => (
            <Stack
              key={i}
              className={item.clickable ? classes.section : classes.sectionDisabled}
              onClick={() => quickReplySelected(item)}
            >
              <Text className={classes.title}>{item.title}</Text>
              <Text color={'gray.6'} className={cx(classes.message, 'truncate')} size={'sm'}>
                {item.text}
              </Text>
            </Stack>
          ))}
        </Stack>
      </Modal>
    </>
  )
}
